"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeTrendOrder = exports.getTrendOrder = exports.getHistoryTrends = exports.getActiveTrends = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const operators_1 = require("rxjs/operators");
function getHost(path) {
    return `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().futureApiHostV2}${path}`;
}
function injectSymbolField(order) {
    order.symbol = `${order.base}/${order.quote}`;
    return order;
}
function processData(res) {
    const items = ((res === null || res === void 0 ? void 0 : res.items) || []).map(injectSymbolField);
    return Object.assign({}, res, { items });
}
/**获取当前活跃的划线下单 */
function getActiveTrends(data) {
    return trade_utils_lib_1.Network.get({
        url: getHost("/smart_trigger/draw_line_order/opening"),
        data,
        authType: trade_utils_lib_1.AuthType.AccessAndTrader,
        signature: true,
    }).pipe((0, operators_1.map)(processData));
}
exports.getActiveTrends = getActiveTrends;
/**获取历史划线下单 */
function getHistoryTrends(data) {
    return trade_utils_lib_1.Network.get({
        url: getHost("/smart_trigger/draw_line_order/closed"),
        data,
        authType: trade_utils_lib_1.AuthType.AccessAndTrader,
        signature: true,
    }).pipe((0, operators_1.map)(processData));
}
exports.getHistoryTrends = getHistoryTrends;
/**通过id获取订单详情 */
function getTrendOrder(bu_order_id) {
    return trade_utils_lib_1.Network.get({
        url: getHost(`/smart_trigger/draw_line_order/${bu_order_id}`),
        authType: trade_utils_lib_1.AuthType.AccessAndTrader,
        signature: true,
    }).pipe((0, operators_1.map)((res) => {
        const order = ((res === null || res === void 0 ? void 0 : res.items) || [])[0];
        if (order) {
            return injectSymbolField(order);
        }
        return undefined;
    }));
}
exports.getTrendOrder = getTrendOrder;
/**取消划线下单 */
function closeTrendOrder(data) {
    return trade_utils_lib_1.Network.delete$({
        url: getHost("/smart_trigger/draw_line_order/"),
        data,
        authType: trade_utils_lib_1.AuthType.AccessAndTrader,
        signature: true,
    });
}
exports.closeTrendOrder = closeTrendOrder;
